export const variationRadioData = [
    {
      text: "Use the ",
      code: "radio ",
    },
    {
      text: "attribute through create variation of radio designs.",
    },
  ];
  
  export const variationRadioDataList = [
    {
      colClass: "col-md-6",
      title: "Select your payment method",
      child: [
        {
          id: 1,
          labelText: "BOB",
          image: "ecommerce/card.png",
          name: "radio1",
        },
        {
          id: 2,
          labelText: "MasterCard",
          image: "ecommerce/mastercard.png",
          check: "checked",
          name: "radio1",
          defaultChecked:true,
        },
        {
          id: 3,
          labelText: "Paypal",
          image: "ecommerce/paypal.png",
          name: "radio1",
        },
        {
          id: 4,
          labelText: "VISA",
          image: "ecommerce/visa.png",
          name: "radio1",
        },
      ],
    },
    {
      colClass: "col-md-6",
      title: "What are the most important things to learn about web design?",
      child: [
        {
          id: 5,
          labelText: "A. HTML",
          name: "radio2",
        },
        {
          id: 6,
          labelText: "B. CSS",
          name: "radio2",
        },
        {
          id: 7,
          labelText: "C. Javascript",
          defaultChecked:true,
          name: "radio2",
        },
        {
          id: 8,
          labelText: "D. Above the all",
          name: "radio2",
        },
      ],
    },
    {
      title: "Radios With Creative Options & SVG Icons",
      child: [
        {
          id: 9,
          labelText: "The notification icon displayed new messages.",
          icon: "notification",
          iconColor: "danger",
          name: "radio3",
        },
        {
          id: 10,
          labelText: "The download icon indicated completion.",
          icon: "stroke-calendar",
          iconColor: "success",
          name: "radio3",
        },
        {
          id: 11,
          labelText: "The tag icon allowed easy categorization.",
          icon: "tag",
          iconColor: "stroke-dark",
          check: "checked",
          name: "radio3",
          defaultChecked:true,
        },
        {
          id: 12,
          labelText: "The email icon was inaccessibly located.",
          icon: "stroke-email",
          iconColor: "primary",
          name: "radio3",
        },
      ],
    },
  ];
  
  export const variationCheckboxData = [
    {
      text: "We can create any creative design by using ",
      code: "(type='checkbox')",
    },
    {
      text: "attribute.",
    },
  ];
  
  export const variationCheckboxDataList = [
    {
      id: 1,
      color: "success",
      labelText: "Reading",
    },
    {
      id: 2,
      color: "success",
      labelText: "Watching TV",
      check: true,
    },
    {
      id: 3,
      color: "danger",
      labelText: "Listening to music",
    },
    {
      id: 4,
      color: "danger",
      labelText: "Playing video games",
    },
    {
      id: 5,
      color: "success",
      labelText: "Painting/Drawing",
    },
  ];
  
  export const upgradeVariationData = [
    {
      id: 1,
      text: "Voxo",
      sales: "270 Sales",
    },
    {
      id: 2,
      text: "Cuba",
      sales: "4.8K Sales",
    },
    {
      id: 3,
      text: "Multikart",
      sales: "2.6k Sales",
    },
    {
      id: 4,
      text: "Viho",
      sales: "2k Sales",
      check: true,
    },
  ];
  
  export const megaOptionDefaultData = [
    {
      text: "This option is show by default you don't need to add any extra class.",
    },
  ];

  export const defaultFormData = [
    {
      id: 1,
      color: "primary",
      badgeTitle: "COD",
      digits: "50 INR",
      shippingText: "Estimated 2 Day Shipping ( Duties end tax may be due delivery )",
    },
    {
      id: 2,
      color: "secondary",
      badgeTitle: "Fast",
      digits: "100 INR",
      shippingText: "Estimated 1 Day Shipping ( Duties end tax may be due delivery )",
    },
  ];
  
  export const withoutBorderData = [
    {
      text: "By adding ",
      code: ".plain-style ",
    },
    {
      text: "class to",
      code: " .mega-inline",
    },
    {
      text: "you can archive this style.",
    },
  ];
  
  export const withoutBorderDataList = [
    {
      id: 1,
      color: "warning",
      badgeTitle: "$39",
      digits: "100 MBPS",
      plansText: "Plans for 2/4/6 months are offered to new clients.",
      check: true,
    },
    {
      id: 2,
      color: "info",
      badgeTitle: "$50",
      digits: "Hired",
      plansText: "Plans for 2 years projects offered to new clients.",
    },
  ];
  
  export const solidBorderStyleData = [
    {
      text: "Use the ",
      code: ".offer-style ",
    },
    {
      text: "class to",
      code: " .mega-inline",
    },
    {
      text: "you can archive this style.",
    },
  ];
  
  export const solidBorderStyleDataList = [
    {
      id: 1,
      image: "blog/img.png",
      spanText: "We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration.",
    },
    {
      id: 2,
      image: "blog/blog.jpg",
      spanText: "When someone visits your homepage, your design should inspire them to stay. Therefore, your value proposition should be established on the homepage for visitors.",
    },
  ];
  
  export const offerBorderStyleData = [
    {
      text: "Use the ",
      code: ".offer-style ",
    },
    {
      text: "class to",
      code: " .mega-inline",
    },
    {
      text: " you can archive this style.",
    },
  ];
  
  export const offerBorderStyleDataList = [
    {
      id: 1,
      color: "success",
      image: "email-template/11.jpg",
      spanText: "Fruits are an essential part of a healthy diet, and offer many health benefits. They're packed with vitamins, minerals, and fiber, which can help improve digestion.",
    },
    {
      id: 2,
      color: "danger",
      image: "email-template/10.jpg",
      spanText: "Flowers have long been used to express feelings and sentiments, and each bloom has its own distinct significance. For instance, while daisies signify innocence and purity.",
      check: true,
    },
  ];
  
  export const inlineStyeData = [
    {
      text: "For Create inline megaoption add ",
      code: ".mega-inline",
    },
    {
      text: " class in form tag",
    },
  ];

  export const inlineStyeDataList = [
    {
      id: 1,
      color: "warning",
      badgeTitle: "COD",
      digits: "50 INR",
      shippingText: "Estimated 14-20 Day Shipping ( Duties end taxes may be due upon delivery )",
    },
    {
      id: 2,
      color: "secondary",
      badgeTitle: "Fast",
      digits: "100 INR",
      shippingText: "Estimated 1 Day Shipping ( Duties end tax may be due upon delivery )",
    },
    {
      id: 3,
      color: "secondary",
      badgeTitle: "Standard",
      digits: "80 INR",
      shipingText: "Estimated 3 Day Shipping ( Duties end taxes may be due upon delivery )",
    },
    {
      id: 4,
      color: "warning",
      badgeTitle: "Local",
      digits: "Free",
      shipingText: "Estimated 15 Day Shipping ( Duties end taxes may be due upon delivery )",
    },
  ];
  
  export const verticalStyleData = [
    {
      text: "vertical style in mega-options. Use the ",
      code: ".mega-vertical ",
    },
    {
      text: "class through created vertical alignments.",
    },
  ];
  
  export const verticalStyleDataList = [
    {
      megaTitle: "Delivery Option",
      child: [
        {
          id: 1,
          color: "primary",
          name: "radio5",
          mediaBodyClass: "megaoption-space",
          badgeTitle: "COD",
          digits: "50 INR",
          spanText: "Estimated 10 to 15 Day Shipping ( Duties end taxes may be due delivery )",
        },
        {
          id: 2,
          color: "secondary",
          name: "radio5",
          mediaBodyClass: "megaoption-space",
          badgeTitle: "Fast",
          digits: "100 INR",
          spanText: "Estimated 10 to 12 Day Shipping ( Duties end tax may be due delivery )",
        },
        {
          id: 3,
          color: "success",
          name: "radio5",
          mediaBodyClass: "megaoption-space",
          badgeTitle: "Standard",
          digits: "80 INR",
          spanText: "Estimated 3 to 5 Day Shipping ( Duties end taxes may be due delivery )",
        },
        {
          id: 4,
          color: "info",
          name: "radio5",
          mediaBodyClass: "megaoption-space",
          badgeTitle: "Local",
          digits: "Free",
          spanText: "Estimated 3 to 5 Day Shipping ( Duties end taxes may be due upon delivery )",
          check: true,
        },
      ],
    },
    {
      megaTitle: "Buying Option",
      child: [
        {
          id: 5,
          color: "warning",
          cardClass: "mb-0",
          name: "radio7",
          badgeTitle: "Pixelstrap",
          digits: "250 INR",
          check: true,
          spanClass: "rating-star-wrapper",
          star: [
            { id: 1, starClass: "txt-warning" },
            { id: 2, starClass: "txt-warning" },
            { id: 3, starClass: "txt-warning" },
            { id: 4, starClass: "txt-warning" },
            { id: 5, starClass: "txt-warning m-r-5" },
          ],
          spanText: "5 start rating",
        },
        {
          id: 6,
          color: "danger",
          cardClass: "mb-0",
          name: "radio7",
          badgeTitle: "Multikart",
          digits: "150 INR",
          spanClass: "rating-star-wrapper",
          star: [{ id: 1, starClass: "txt-warning" }, { id: 2, starClass: "txt-warning" }, { id: 3 }, { id: 4 }, { id: 5, starClass: "m-r-5" }],
          spanText: "2 start rating",
        },
      ],
    },
  ];
  
  export const horizontalStyleData = [
    {
      text: "horizontal style in mega-options. Use the ",
      code: ".mega-horizontal",
    },
    {
      text: "class through created vertical alignments.",
    },
  ];
  
  export const horizontalStyleDataList = [
    {
      megaTitle: "Delivery Option",
      child: [
        {
          id: 1,
          color: "primary",
          name: "radio22",
          mediaBodyClass: "megaoption-space",
          badgeTitle: "COD",
          digits: "50 INR",
          spanText: "Estimated 5 Day Shipping ( Duties end taxes may be due delivery )",
        },
        {
          id: 2,
          colClass: "offset-sm-3",
          color: "secondary",
          name: "radio22",
          mediaBodyClass: "megaoption-space",
          badgeTitle: "Fast",
          digits: "100 INR",
          spanText: "Estimated 1 Day Shipping ( Duties end tax may be due delivery )",
          check: true,
        },
      ],
    },
    {
      megaTitle: "Buying Option",
      child: [
        {
          id: 3,
          color: "success",
          name: "radios23",
          badgeTitle: "Pixelstrap",
          digits: "250 INR",
          spanClass: "rating-star-wrapper",
          star: [
            { id: 1, starClass: "txt-warning" },
            { id: 2, starClass: "txt-warning" },
            { id: 3, starClass: "txt-warning" },
            { id: 4, starClass: "txt-warning" },
            { id: 5, starClass: "txt-warning m-r-5" },
          ],
          spanText: "5 start rating",
        },
        {
          id: 4,
          colClass: "offset-sm-3",
          cardClass: "mb-0",
          color: "info",
          name: "radios23",
          badgeTitle: "Tivo",
          digits: "150 INR",
          check: true,
          spanClass: "rating-star-wrapper",
          star: [{ id: 1, starClass: "txt-warning" }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5, starClass: "m-r-5" }],
          spanText: "1 start rating",
        },
      ],
    },
  ];